import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import qs from 'qs';
import { bindActionCreators } from 'redux';
import { Form, actions } from 'react-redux-form/immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {
  Button, Card, CardBody, CardTitle,
} from 'reactstrap';
import {
  getVolcanoLocations as getVolcanoLocationsAc,
  clearVolcanoLocations as clearVolcanoLocationsAc,
  getCountries as getCountriesAc,
  getRegions as getRegionsAc,
  getEruptionTimes as getEruptionTimesAc,
  getMorphologies as getMorphologiesAc,
  getStatuses as getStatusesAc,
} from '../../../../../../redux/volcanoes/location/search/volcanoLocationSearchActions';
import { LabeledSelect } from '../../../../../form/LabeledSelect';
import { volcanoLocationSearchModel, toSearchParameters } from './volcanoLocationSearchModel';
import { Loading } from '../../../../../loadbar/Loading';
import { TextMatchSearchCard } from '../../../../../form/search/TextMatchSearchCard';
import { LatLongSearchCard } from '../../../../../form/search/LatLongSearchCard';
import { LabeledText } from '../../../../../form/LabeledText';
import { isDataManager } from '../../../../../../role/roleUtils';

const model = volcanoLocationSearchModel.get('name');


class VolcanoLocSearchPageUnwrapped extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    document.title = 'NCEI Hazard Volcano Location Search';
    const {
      clearVolcanoLocations,
      getCountries,
      getRegions,
      getMorphologies,
      getStatuses,
      getEruptionTimes,
      history,
    } = this.props;
    clearVolcanoLocations();
    getCountries({ history });
    getRegions({ history });
    getMorphologies({ history });
    getStatuses({ history });
    getEruptionTimes({ history });
  }

  handleSubmit(form) {
    const { getVolcanoLocations, history } = this.props;
    const queryParameters = toSearchParameters(form);
    const location = {
      pathname: '/view/hazards/volcano/loc-data',
      search: qs.stringify(toSearchParameters(form), { skipNulls: true }),
    };
    getVolcanoLocations({
      queryParameters, formModel: model, history, location, searchRedirect: true,
    });
  }

  render() {
    const {
      searching,
      resetForm,
      countries,
      regions,
      morphologies,
      statuses,
      eruptionTimes,
      fetched,
      authorities,
    } = this.props;
    if (searching || !fetched) {
      return (<Loading />);
    }

    const regionsJs = regions.toJS().map(x => ({ id: x.id, description: `${(`00${x.id}`).slice(-2)} - ${x.description}` }));

    const dataManager = isDataManager(authorities);

    return (
      <div className="haz-results-container haz-page-container">
        <Card className="haz-page-card">
          <CardBody>
            <CardTitle tag="h1" className="haz-page-card-title">Search Volcano Locations</CardTitle>
            <p>
              The Volcano Locations Database is a global listing of
              over 1600 volcanoes which includes information on the
              latitude, longitude, elevation, type of volcano, and last
              known eruption. These data are from the Smithsonian Institution
              Global Volcanism Program (GVP), &quot;Volcanoes of the World&quot;
              publication. Please go to their website for additional volcano
              status and eruption information.

            </p>
            <p>
              Please cite as:
              <br />
              <a href="https://data.noaa.gov/metaview/page?xml=NOAA/NESDIS/NGDC/MGG/Hazards//iso/xml/G02135.xml&view=getDataView&header=none" rel="noopener noreferrer" target="_blank" title="Volcano Location Information" aria-label="Volcano Location Information">NCEI Volcano Location Database. NOAA National Centers for Environmental Information.</a>
            </p>
            <Form model={model} onSubmit={this.handleSubmit} noValidate>

              <div>
                <Button color="primary" type="submit" className="ml-5">Search</Button>
                <Button color="secondary" className="ml-3" onClick={resetForm}>Clear</Button>
              </div>
              <br />

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Volcano Parameters</CardTitle>

                  {dataManager && (
                  <div className="form-row">
                    <LabeledText
                      formGroupClassName={['col-sm-4']}
                      model=".id"
                      label="NCEI ID"
                    />
                    <LabeledText
                      formGroupClassName={['col-sm-4']}
                      model=".num"
                      label="Previous Volcano Number"
                    />
                    <LabeledText
                      formGroupClassName={['col-sm-4']}
                      model=".newNum"
                      label="Volcano Number"
                    />
                  </div>
                  )}

                  <TextMatchSearchCard
                    radioGroupModel=".radios.nameSearchType"
                    textModel=".radios.name"
                    startsWith="nameStart"
                    includes="nameInclude"
                    matches="nameMatch"
                    doesNotMatch="nameNot"
                    helpModalId="volLocName"
                  >
                    Volcano Name
                  </TextMatchSearchCard>

                  <div className="form-row">
                    <LabeledSelect
                      formGroupClassName={['col-lg-6']}
                      parentModel={model}
                      fieldId="country"
                      label="Country"
                      filterable
                      helpModalId="volEventCountry"
                      childOptions={countries.toJS()}
                    />

                    <LabeledSelect childOptions={regionsJs} formGroupClassName={['col-lg-6']} parentModel={model} fieldId="region" label="Region" filterable helpModalId="volLocRegions" />
                  </div>

                  <LatLongSearchCard model={model} />

                  <div className="form-row">
                    <LabeledSelect childOptions={morphologies.toJS()} formGroupClassName={['col-lg-4']} parentModel={model} fieldId="morphology" label="Volcano Type" filterable helpModalId="volLocType" />
                    <LabeledSelect childOptions={statuses.toJS()} formGroupClassName={['col-lg-4']} parentModel={model} fieldId="status" label="Volcano Status" filterable helpModalId="volLocStatus" />
                    <LabeledSelect childOptions={eruptionTimes.toJS()} formGroupClassName={['col-lg-4']} parentModel={model} fieldId="timeErupt" label="Time of Eruption" filterable helpModalId="volLocTimeErupt" />
                  </div>
                </CardBody>
              </Card>

              <br />
              <div>
                <Button color="primary" type="submit" aria-label="Search Option 2" className="ml-5">Search</Button>
                <Button color="secondary" className="ml-3" aria-label="Clear Option 2" onClick={resetForm}>Clear</Button>
              </div>

              <br />

            </Form>
          </CardBody>
        </Card>
      </div>
    );
  }
}

VolcanoLocSearchPageUnwrapped.propTypes = {
  history: PropTypes.shape({}).isRequired,
  getVolcanoLocations: PropTypes.func.isRequired,
  clearVolcanoLocations: PropTypes.func.isRequired,
  searching: PropTypes.bool.isRequired,
  resetForm: PropTypes.func.isRequired,
  countries: ImmutablePropTypes.list.isRequired,
  regions: ImmutablePropTypes.list.isRequired,
  morphologies: ImmutablePropTypes.list.isRequired,
  statuses: ImmutablePropTypes.list.isRequired,
  eruptionTimes: ImmutablePropTypes.list.isRequired,
  getCountries: PropTypes.func.isRequired,
  getRegions: PropTypes.func.isRequired,
  getMorphologies: PropTypes.func.isRequired,
  getStatuses: PropTypes.func.isRequired,
  getEruptionTimes: PropTypes.func.isRequired,
  fetched: PropTypes.bool.isRequired,
  authorities: ImmutablePropTypes.list.isRequired,
};


const mapStateToProps = state => ({
  searching: state.getIn(['volcanoLocationSearchPage', 'searching']),
  countries: state.getIn(['volcanoLocationSearchPage', 'countries']),
  regions: state.getIn(['volcanoLocationSearchPage', 'regions']),
  morphologies: state.getIn(['volcanoLocationSearchPage', 'morphologies']),
  statuses: state.getIn(['volcanoLocationSearchPage', 'statuses']),
  eruptionTimes: state.getIn(['volcanoLocationSearchPage', 'eruptionTimes']),
  fetched: [
    state.getIn(['volcanoLocationSearchPage', 'fetchedRegions']),
    state.getIn(['volcanoLocationSearchPage', 'fetchedCountries']),
    state.getIn(['volcanoLocationSearchPage', 'fetchedMorphologies']),
    state.getIn(['volcanoLocationSearchPage', 'fetchedStatuses']),
    state.getIn(['volcanoLocationSearchPage', 'fetchedEruptionTimes']),
  ].every(v => v),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  getVolcanoLocations: getVolcanoLocationsAc,
  clearVolcanoLocations: clearVolcanoLocationsAc,
  resetForm: () => actions.reset(model),
  getCountries: getCountriesAc,
  getRegions: getRegionsAc,
  getEruptionTimes: getEruptionTimesAc,
  getMorphologies: getMorphologiesAc,
  getStatuses: getStatusesAc,
}, dispatch);


export const VolcanoLocSearchPage = connect(mapStateToProps, mapDispatchToProps)(VolcanoLocSearchPageUnwrapped);
